/**
 * The pricing cards template's plan lines and strings for the billing page (Emily, 2026-10-25: 'all pricing cards sections should be templates'). A copy of OverlayQALaunch src/data/pricing.ts (fit, extras, the Starter feature list) and src/data/pricing-cards-copy.json; that repo's scripts/pricing-cards-data.mjs fails its build when this file drifts from them. Prices are NOT here: they come from Clerk through /api/billing/plans.
 *
 * The object below is plain JSON (OverlayQALaunch scripts/pricing-cards-data.mjs parses it as such to compare), so keep
 * it quoted JSON.
 */
export const PRICING_CARD = {
  "plans": {
    "starter": {
      "fit": "For freelancers",
      "extras": []
    },
    "team": {
      "fit": "For small agencies",
      "extras": [
        "Team invitations"
      ]
    },
    "pro": {
      "fit": "For larger teams",
      "extras": [
        "Priority support"
      ]
    }
  },
  "features": [
    "Unlimited projects",
    "Smart Capture & AI Issue Generation",
    "Auto Review",
    "AI Visual Comparison",
    "Visual Comparison",
    "Accessibility Audit",
    "Design Tokens",
    "Components",
    "Shareable issue links (no login required)",
    "Branded client feedback portal",
    "Jira, Linear, Notion, Asana, Trello, ClickUp, GitHub Issues, Basecamp & monday.com export",
    "Slack notifications"
  ],
  "copy": {
    "toggle": {
      "label": "Billing period",
      "monthly": "Monthly",
      "annual": "Annual",
      "chip": "Save up to {pct}%"
    },
    "save": {
      "monthly": "Save {amount} a year with annual billing",
      "annual": "You save {amount} a year"
    },
    "marketing": {
      "billedMonthly": "Billed monthly",
      "billedYearly": "{amount} billed yearly"
    },
    "seats": {
      "included": "included",
      "extraPrice": "Extra seats: {price}/seat/month"
    },
    "stepper": {
      "label": "Total seats",
      "remove": "Remove a {name} seat",
      "add": "Add a {name} seat",
      "inputLabel": "{name} total seats",
      "tooBig": "Contact sales for a team of this size.",
      "minimum": "Minimum {n} seats for your current team.",
      "choose": "Choose seats for your whole team, including you.",
      "breakdown": "{base} plan + {cost} for {n} extra {seats}/mo",
      "allIncluded": "All selected seats are included in the plan."
    },
    "features": {
      "show": "Show all {n} features",
      "hide": "Hide features"
    },
    "billing": {
      "monthlyTotal": "{amount}/month total, before tax.",
      "yearlyTotal": "{amount} billed yearly, before tax.",
      "continue": "Continue with {name}",
      "startsToday": "Billing starts today.",
      "trialBadge": "Your trial plan"
    }
  }
} as const;
